<template>
  <div
    class="freestyle-canvas-preview container-fluid overflow-hidden"
    v-if="slide && slide.id"
  >
    <div v-if="blocksReady">
      <PreviewBlockEditor
        v-for="(block) in previewBlocksArray"
        :class="['block-editor', `${location}-block-editor`]"
        :key="`${location}-${slide.id}-${block.id}`"
        :block="{...block, id: `${location}-${slide.id}-${block.id}`}"
        :slide-id="slide.id"
      />
    </div>
  </div>
</template>

<script>
import util from '@/util'
import PreviewBlockEditor from '@/components-v2/presentation-editor/freestyle/PreviewBlockEditor.vue'
import { DefaultCanvasBlocks } from '@/utils/CanvasBlocksLayout'

export default {
  components: {
    PreviewBlockEditor,
  },
  props: {
    slide: {
      type: Object,
      default: null,
    },
    location: {
      type: String,
      default: 'preview',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateBlocksArray: [],
      blocksReady: false,
    }
  },
  computed: {
    canvasBlocks() {
      if (!this.slide) return {}
      if (this.slide.convertedFromDocument) {
        return {}
      }
      if (!this.slide.canvasBlocksUrl) {
        const canvasBlocks = DefaultCanvasBlocks(this.slide.id)

        if (!this.slide.canvasBlocks) {
          Object.keys(canvasBlocks).forEach((blockId) => {
            const block = canvasBlocks[blockId]
            if (block.tag === 'heading' && this.slide.titleHTML) {
              canvasBlocks[blockId].content.value = this.slide.titleHTML
            }
            if (block.tag === 'content' && (this.slide.bodyHTML || this.slide.subheading)) {
              canvasBlocks[blockId].content.value = this.slide.bodyHTML || this.slide.subheading
            }
          })
          return canvasBlocks
        }
      }
      return this.slide.canvasBlocks
    },

    previewBlocksArray() {
      if (this.readonly) {
        return this.templateBlocksArray
      }
      const originalBlocks = util.convertBlocksMapToArray(this.canvasBlocks, 'id')
      if (!originalBlocks) return []
      return originalBlocks
        .map((block) => {
          return {
            ...block,
            // make the id for thumbnail preview different from the counterpart on the canvas
            // so that they won't conflict
            id: `${this.location}-${block.id}`,
          }
        })
    },

  },
  mounted() {
    if (this.slide && this.slide.canvasBlocks && this.readonly) {
      this.templateBlocksArray = util.convertBlocksMapToArray(this.slide.canvasBlocks, 'id')
    }
    this.$nextTick(() => {
      this.blocksReady = true
    })
  },
}
</script>

<style lang="scss" scoped>
.freestyle-canvas-preview {
  width: 100%;
  height: 100%;
  padding-left: 1px;
  padding-top: 7px;
  pointer-events: none;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.block-editor {
  transform-origin: top left;
  transform: scale(0.125, 0.125);
}
.templates-block-editor {
  transform: scale(0.121, 0.121);
}

.preview-header {
  height: 8px;
}

.preview-footer {
  height: 8px;
}

</style>
